import {v4 as uuidv4} from 'uuid';
import {UploadLocation} from '../enum/upload-location';

export class FileUploadStatus {
  internalId: string;
  fileIcon: string;
  fileName: string;
  fileSecret: string;
  fileHash: string;
  fileSize: number;
  fileType: string;
  progress: number;
  id: string;
  uploadLocation: UploadLocation;
  isError: boolean = false;

  constructor(filename: string,
              fileIcon: string,
              fileSize: number,
              fileType: string,
              uploadLocation: UploadLocation,
              progress: number = 0,
              id: string = null,
              internalId: string = null,
              fileSecret: string = null
  ) {
    this.fileName = filename;
    this.fileIcon = fileIcon;
    this.fileSize = fileSize;
    this.fileType = fileType;
    this.progress = progress;
    this.uploadLocation = uploadLocation;
    this.id = id;
    this.fileSecret = fileSecret;
    if (internalId !== null)
      this.internalId = internalId;
    else
      this.internalId = uuidv4();
  }
}
